import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import Button from "components/inputs/button"
import {EmailTemplate} from "models"
import EmailTemplatesTable from "components/email-templates/table"
import memo from "set-state-compare/src/memo"
import React from "react"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminEmailTemplatesIndex extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.email_templates.index"})

    this.canCan = useCanCan(() => [[EmailTemplate, ["create"]]])
    this.t = t

    useAdminLayout()?.setState({actions: this.actions(), active: "email-templates", headerTitle: EmailTemplate.modelName().human({count: 2})})
  }

  render() {
    return (
      <View dataSet={{route: "admin--email-templates--index"}}>
        <EmailTemplatesTable adminLayout />
      </View>
    )
  }

  actions() {
    const {canCan, t} = this.tt

    return (
      <>
        {canCan?.can("create", EmailTemplate) &&
          <Button
            className="new-email-template-button"
            icon="plus"
            label={t(".add_new_email_template")}
            to={Routes.newAdminEmailTemplatePath()}
          />
        }
      </>
    )
  }
}))
